@use '../../../scss/settings/colors';

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: -61px 0 32px;

  h1 {
    margin-bottom: 8px;
    color: colors.$dark-blue;
    font-size: 26px;
    line-height: 150%;
  }
}

.breadcrumbs {
  display: flex;
  align-items: center;
  gap: 8px;
  color: colors.$gray-variant-16;
  
  .documentViewText{
    text-decoration-color: colors.$brand-purple;
    text-decoration-thickness: 1.5px;
    text-underline-offset: 6px;
    font-size: 14px;
  }

  a {
    text-decoration: underline;
    color: colors.$brand-purple;

    &:hover {
      text-decoration: none;
    }

  }

}

.separator {
  color: colors.$gray-variant-16;
}

.gridItem {
  position: relative;
  background: colors.$base-white;
  border-radius: 8px;
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.1);
  padding: 8px 16px 0;
 // height: 100%;
}

.gridItemBoxShadow {
  border-radius: 8px;
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.1);
}

.tabs {
  height: 40px;
  display: flex;
  align-items: center;

  .tab {
    padding: 0 16px;
    text-transform: none;
    color: colors.$gray-variant-16;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    min-width: 120px;

    &:hover {
      color: colors.$brand-purple;
    }

    &.activeTab {
      color: colors.$brand-purple;
    }
  }
}

.tabContent {
 // min-height: calc(100vh - 200px);
}

.card_border {
  border: 1px solid colors.$brand-purple;
  animation: pulse 0.4s ease-in-out;
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
  100% {
    transform: scale(1);
  }
}

